<template>
  <v-container>
    <!-- <v-layout justify-space-between>
      <h1>New Fixed Cost Trip</h1>
    </v-layout>-->
    <v-layout justify-center py-3 row wrap>
      <v-flex xs12 md10 xl8>
        <SimpleCard>
          <v-layout justify-start align-content-start row wrap>
            <v-flex xs12>
              <h4>Dispatcher Settings</h4>
            </v-flex>
            <v-flex xs7>
              <v-row align="center">
                <v-flex pr-2>
                  <v-text-field
                    type="number"
                    v-model="jobOfferTimeout"
                    label="Job Offer Timeout (Seconds)"
                  ></v-text-field>
                </v-flex>
                <v-btn @click="updateJobOfferTimeout" small>Update</v-btn>
              </v-row>
            </v-flex>
            <v-flex xs7>
              <v-row>
                <v-flex pr-2>
                  <v-checkbox
                    single-line
                    v-model="useZoneBasedDispatch"
                    label="Use Zone based dispatching"
                  ></v-checkbox>
                </v-flex>
                <v-btn @click="updateZoneBasedDispatch" small>Update</v-btn>
              </v-row>
            </v-flex>
          </v-layout>
        </SimpleCard>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Overview from "@/components/settings/Overview.vue";

import SimpleCard from "@/components/widget/SimpleCard.vue";

import axios from "axios";
axios.defaults.withCredentials = true;

import qs from "qs";

export default {
  name: "fixed_pricing",
  components: {
    Overview,
    SimpleCard
  },
  data: function() {
    return {
      loading: false,
      jobOfferTimeout: null,
      useZoneBasedDispatch: null
    };
  },
  mounted: async function() {
    this.getDispatcherSettings();
  },
  methods: {
    getDispatcherSettings: function(p) {
      this.loading = true;

      var url = `${this.$store.state.apiUrl}/dispatcher/settings/get`;

      var vm = this;

      axios({
        url: url,
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          if (res.data.error == "no_error") {
            vm.jobOfferTimeout = res.data.jobOfferTimeout;
            vm.useZoneBasedDispatch = res.data.useZoneBasedDispatch;
          } else {
            alert("Failed to get settings");
          }
        })
        .catch(function(err) {
          alert("Internal Server Error");
          console.error(err);
        });
    },
    updateJobOfferTimeout: function(p) {
      console.log("Form Submitted");

      this.loading = true;

      var url = `${this.$store.state.apiUrl}/dispatcher/settings/jobOfferTimeout?jobOfferTimeout=${this.jobOfferTimeout}`;

      var completed = this.success;

      axios({
        url: url,
        method: "POST",
        data: qs.stringify(p),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          if (res.data.error == "no_error") {
            alert("Job offer timeout updated");
          } else {
            alert(
              "Job offer timeout failed to update: " + res.data.error.message
            );
          }
        })
        .catch(function(err) {
          alert("Internal Server Error");
        });
    },
    updateZoneBasedDispatch: function(p) {
      console.log("Form Submitted");

      this.loading = true;

      var url = `${this.$store.state.apiUrl}/dispatcher/settings/useZoneBasedDispatch?useZoneBasedDispatch=${this.useZoneBasedDispatch}`;

      var completed = this.success;

      axios({
        url: url,
        method: "POST",
        data: qs.stringify(p),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          if (res.data.error == "no_error") {
            alert("Zone based dispatch updated");
          } else {
            alert(
              "Zone based dispatch failed to update: " + res.data.error.message
            );
          }
        })
        .catch(function(err) {
          alert("Internal Server Error");
        });
    }
  }
};
</script>
